
import { Vue, Component } from 'vue-property-decorator'
import { downloadFile } from '@/api/guarantee'
@Component
export default class GuaranteeInfo extends Vue {
  url = ''
  obj = {
    text: ''
  }
  handleBack() {
    this.$router.go(-1)
  }
  mounted() {
    console.log('this.fileUrl222', this.$route.query.fileUrl)
    // this.url = 'https://www.baidu.com'
    this.showFileInfo()
  }
  showFileInfo() {
    downloadFile({ filePath: this.$route.query.fileUrl }).then((res) => {
      console.log('this.fileUrl333', res)

      let result = res.data
      const blobType = 'text/html'
      const blob = new Blob([result])
      this.url = window.URL.createObjectURL(blob)
      var reader = new FileReader()
      let that = this.obj
      reader.readAsText(blob)
      reader.onload = function () {
        var text: any = reader.result
        // console.log(text.split('<body>')[1].split('</body>')[0])
        that.text = text.split('<body>')[1].split('</body>')[0] as string
        console.log('text', text)
      }
      reader.onerror = function (e) {
        console.log('Error', e)
      }
    })
  }
}
